import { render, staticRenderFns } from "./TicketsUpload.vue?vue&type=template&id=0cf4d2fa&"
import script from "./TicketsUpload.vue?vue&type=script&lang=ts&"
export * from "./TicketsUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports